import React, { SyntheticEvent, useEffect } from "react";
import _ from "lodash";

import {
  CN,
  FR,
  US,
  IE,
  AU,
  NL,
  NZ,
  GB,
  ES,
  IL,
  MY,
  LT,
} from "country-flag-icons/react/1x1";
import ReactGA4 from "react-ga4";
import { DateTime, Duration } from "luxon";
import { image_placeholder_s3 } from "../variables";

export const currencies = {
  AED: "د.إ",
  AFN: "؋",
  ALL: "L",
  AMD: "֏",
  ANG: "ƒ",
  AOA: "Kz",
  ARS: "$",
  AUD: "$",
  AWG: "ƒ",
  AZN: "₼",
  BAM: "KM",
  BBD: "$",
  BDT: "৳",
  BGN: "лв",
  BHD: ".د.ب",
  BIF: "FBu",
  BMD: "$",
  BND: "$",
  BOB: "$b",
  BOV: "BOV",
  BRL: "R$",
  BSD: "$",
  BTC: "₿",
  BTN: "Nu.",
  BWP: "P",
  BYN: "Br",
  BYR: "Br",
  BZD: "BZ$",
  CAD: "$",
  CDF: "FC",
  CHE: "CHE",
  CHF: "CHF",
  CHW: "CHW",
  CLF: "CLF",
  CLP: "$",
  CNY: "¥",
  COP: "$",
  COU: "COU",
  CRC: "₡",
  CUC: "$",
  CUP: "₱",
  CVE: "$",
  CZK: "Kč",
  DJF: "Fdj",
  DKK: "kr",
  DOP: "RD$",
  DZD: "دج",
  EEK: "kr",
  EGP: "£",
  ERN: "Nfk",
  ETB: "Br",
  ETH: "Ξ",
  EUR: "€",
  FJD: "$",
  FKP: "£",
  GBP: "£",
  GEL: "₾",
  GGP: "£",
  GHC: "₵",
  GHS: "GH₵",
  GIP: "£",
  GMD: "D",
  GNF: "FG",
  GTQ: "Q",
  GYD: "$",
  HKD: "$",
  HNL: "L",
  HRK: "kn",
  HTG: "G",
  HUF: "Ft",
  IDR: "Rp",
  ILS: "₪",
  IMP: "£",
  INR: "₹",
  IQD: "ع.د",
  IRR: "﷼",
  ISK: "kr",
  JEP: "£",
  JMD: "J$",
  JOD: "JD",
  JPY: "¥",
  KES: "KSh",
  KGS: "лв",
  KHR: "៛",
  KMF: "CF",
  KPW: "₩",
  KRW: "₩",
  KWD: "KD",
  KYD: "$",
  KZT: "₸",
  LAK: "₭",
  LBP: "£",
  LKR: "₨",
  LRD: "$",
  LSL: "M",
  LTC: "Ł",
  LTL: "Lt",
  LVL: "Ls",
  LYD: "LD",
  MAD: "MAD",
  MDL: "lei",
  MGA: "Ar",
  MKD: "ден",
  MMK: "K",
  MNT: "₮",
  MOP: "MOP$",
  MRO: "UM",
  MRU: "UM",
  MUR: "₨",
  MVR: "Rf",
  MWK: "MK",
  MXN: "$",
  MXV: "MXV",
  MYR: "RM",
  MZN: "MT",
  NAD: "$",
  NGN: "₦",
  NIO: "C$",
  NOK: "kr",
  NPR: "₨",
  NZD: "$",
  OMR: "﷼",
  PAB: "B/.",
  PEN: "S/.",
  PGK: "K",
  PHP: "₱",
  PKR: "₨",
  PLN: "zł",
  PYG: "Gs",
  QAR: "﷼",
  RMB: "￥",
  RON: "lei",
  RSD: "Дин.",
  RUB: "₽",
  RWF: "R₣",
  SAR: "﷼",
  SBD: "$",
  SCR: "₨",
  SDG: "ج.س.",
  SEK: "kr",
  SGD: "S$",
  SHP: "£",
  SLL: "Le",
  SOS: "S",
  SRD: "$",
  SSP: "£",
  STD: "Db",
  STN: "Db",
  SVC: "$",
  SYP: "£",
  SZL: "E",
  THB: "฿",
  TJS: "SM",
  TMT: "T",
  TND: "د.ت",
  TOP: "T$",
  TRL: "₤",
  TRY: "₺",
  TTD: "TT$",
  TVD: "$",
  TWD: "NT$",
  TZS: "TSh",
  UAH: "₴",
  UGX: "USh",
  USD: "$",
  UYI: "UYI",
  UYU: "$U",
  UYW: "UYW",
  UZS: "лв",
  VEF: "Bs",
  VES: "Bs.S",
  VND: "₫",
  VUV: "VT",
  WST: "WS$",
  XAF: "FCFA",
  XBT: "Ƀ",
  XCD: "$",
  XOF: "CFA",
  XPF: "₣",
  XSU: "Sucre",
  XUA: "XUA",
  YER: "﷼",
  ZAR: "R",
  ZMW: "ZK",
  ZWD: "Z$",
  ZWL: "$",
};

export const countries = {
  AF: "Afghanistan",
  AL: "Albania",
  DZ: "Algeria",
  AS: "American Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua and Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BA: "Bosnia and Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brazil",
  IO: "British Indian Ocean Territory",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  CV: "Cabo Verde",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  KY: "Cayman Islands",
  CF: "Central African Republic",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Christmas Island",
  CO: "Colombia",
  KM: "Comoros",
  CG: "Congo",
  CR: "Costa Rica",
  HR: "Croatia",
  CU: "Cuba",
  CW: "Curaçao",
  CY: "Cyprus",
  CZ: "Czechia",
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  SZ: "Eswatini",
  ET: "Ethiopia",
  FK: "Falkland Islands (Malvinas)",
  FO: "Faroe Islands",
  FJ: "Fiji",
  FI: "Finland",
  FR: "France",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Greece",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran",
  IQ: "Iraq",
  IE: "Ireland",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KR: "Korea",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Laos",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MO: "Macao",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshall Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  MD: "Moldova",
  MC: "Monaco",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Netherlands",
  NC: "New Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MK: "North Macedonia",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PN: "Pitcairn",
  PL: "Poland",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Romania",
  RU: "Russian Federation",
  RW: "Rwanda",
  BL: "Saint Barthélemy",
  WS: "Samoa",
  SA: "Saudi Arabia",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon Islands",
  SO: "Somalia",
  ZA: "South Africa",
  SS: "South Sudan",
  ES: "Spain",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SE: "Sweden",
  CH: "Switzerland",
  SY: "Syrian Arab Republic",
  TW: "Taiwan",
  TJ: "Tajikistan",
  TZ: "Tanzania",
  TH: "Thailand",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad and Tobago",
  TN: "Tunisia",
  TR: "Turkey",
  TM: "Turkmenistan",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "United Arab Emirates",
  GB: "United Kingdom",
  US: "United States of America",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Viet Nam",
  VG: "Virgin Islands (British)",
  VI: "Virgin Islands (U.S.)",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
};

export const countryCodes = {
  Afghanistan: "AF",
  Albania: "AL",
  Algeria: "DZ",
  "American Samoa": "AS",
  Andorra: "AD",
  Angola: "AO",
  Anguilla: "AI",
  Antarctica: "AQ",
  "Antigua and Barbuda": "AG",
  Argentina: "AR",
  Armenia: "AM",
  Aruba: "AW",
  Australia: "AU",
  Austria: "AT",
  Azerbaijan: "AZ",
  Bahamas: "BS",
  Bahrain: "BH",
  Bangladesh: "BD",
  Barbados: "BB",
  Belarus: "BY",
  Belgium: "BE",
  Belize: "BZ",
  Benin: "BJ",
  Bermuda: "BM",
  Bhutan: "BT",
  Bolivia: "BO",
  "Bosnia and Herzegovina": "BA",
  Botswana: "BW",
  "Bouvet Island": "BV",
  Brazil: "BR",
  "British Indian Ocean Territory": "IO",
  "Brunei Darussalam": "BN",
  Bulgaria: "BG",
  "Burkina Faso": "BF",
  Burundi: "BI",
  "Cabo Verde": "CV",
  Cambodia: "KH",
  Cameroon: "CM",
  Canada: "CA",
  "Cayman Islands": "KY",
  "Central African Republic": "CF",
  Chad: "TD",
  Chile: "CL",
  China: "CN",
  "Christmas Island": "CX",
  Colombia: "CO",
  Comoros: "KM",
  Congo: "CG",
  "Costa Rica": "CR",
  Croatia: "HR",
  Cuba: "CU",
  Curaçao: "CW",
  Cyprus: "CY",
  Czechia: "CZ",
  Denmark: "DK",
  Djibouti: "DJ",
  Dominica: "DM",
  "Dominican Republic": "DO",
  Ecuador: "EC",
  Egypt: "EG",
  "El Salvador": "SV",
  "Equatorial Guinea": "GQ",
  Eritrea: "ER",
  Estonia: "EE",
  Eswatini: "SZ",
  Ethiopia: "ET",
  "Falkland Islands (Malvinas)": "FK",
  "Faroe Islands": "FO",
  Fiji: "FJ",
  Finland: "FI",
  France: "FR",
  Gabon: "GA",
  Gambia: "GM",
  Georgia: "GE",
  Germany: "DE",
  Ghana: "GH",
  Gibraltar: "GI",
  Greece: "GR",
  Greenland: "GL",
  Grenada: "GD",
  Guadeloupe: "GP",
  Guam: "GU",
  Guatemala: "GT",
  Guernsey: "GG",
  Guinea: "GN",
  "Guinea-Bissau": "GW",
  Guyana: "GY",
  Haiti: "HT",
  Honduras: "HN",
  "Hong Kong": "HK",
  Hungary: "HU",
  Iceland: "IS",
  India: "IN",
  Indonesia: "ID",
  Iran: "IR",
  Iraq: "IQ",
  Ireland: "IE",
  Israel: "IL",
  Italy: "IT",
  Jamaica: "JM",
  Japan: "JP",
  Jersey: "JE",
  Jordan: "JO",
  Kazakhstan: "KZ",
  Kenya: "KE",
  Kiribati: "KI",
  Korea: "KR",
  Kuwait: "KW",
  Kyrgyzstan: "KG",
  Laos: "LA",
  Latvia: "LV",
  Lebanon: "LB",
  Lesotho: "LS",
  Liberia: "LR",
  Libya: "LY",
  Liechtenstein: "LI",
  Lithuania: "LT",
  Luxembourg: "LU",
  Macao: "MO",
  Madagascar: "MG",
  Malawi: "MW",
  Malaysia: "MY",
  Maldives: "MV",
  Mali: "ML",
  Malta: "MT",
  "Marshall Islands": "MH",
  Martinique: "MQ",
  Mauritania: "MR",
  Mauritius: "MU",
  Mayotte: "YT",
  Mexico: "MX",
  Moldova: "MD",
  Monaco: "MC",
  Mongolia: "MN",
  Montenegro: "ME",
  Montserrat: "MS",
  Morocco: "MA",
  Mozambique: "MZ",
  Myanmar: "MM",
  Namibia: "NA",
  Nauru: "NR",
  Nepal: "NP",
  Netherlands: "NL",
  "New Caledonia": "NC",
  "New Zealand": "NZ",
  Nicaragua: "NI",
  Niger: "NE",
  Nigeria: "NG",
  Niue: "NU",
  "Norfolk Island": "NF",
  "North Macedonia": "MK",
  Norway: "NO",
  Oman: "OM",
  Pakistan: "PK",
  Palau: "PW",
  Panama: "PA",
  "Papua New Guinea": "PG",
  Paraguay: "PY",
  Peru: "PE",
  Philippines: "PH",
  Pitcairn: "PN",
  Poland: "PL",
  Portugal: "PT",
  "Puerto Rico": "PR",
  Qatar: "QA",
  Réunion: "RE",
  Romania: "RO",
  "Russian Federation": "RU",
  Rwanda: "RW",
  "Saint Barthélemy": "BL",
  Samoa: "WS",
  "Saudi Arabia": "SA",
  Senegal: "SN",
  Serbia: "RS",
  Seychelles: "SC",
  "Sierra Leone": "SL",
  Singapore: "SG",
  Slovakia: "SK",
  Slovenia: "SI",
  "Solomon Islands": "SB",
  Somalia: "SO",
  "South Africa": "ZA",
  "South Sudan": "SS",
  Spain: "ES",
  "Sri Lanka": "LK",
  Sudan: "SD",
  Suriname: "SR",
  Sweden: "SE",
  Switzerland: "CH",
  "Syrian Arab Republic": "SY",
  Taiwan: "TW",
  Tajikistan: "TJ",
  Tanzania: "TZ",
  Thailand: "TH",
  Togo: "TG",
  Tokelau: "TK",
  Tonga: "TO",
  "Trinidad and Tobago": "TT",
  Tunisia: "TN",
  Turkey: "TR",
  Turkmenistan: "TM",
  Tuvalu: "TV",
  Uganda: "UG",
  Ukraine: "UA",
  "United Arab Emirates": "AE",
  "United Kingdom": "GB",
  UK: "GB",
  "United States of America": "US",
  USA: "US",
  Uruguay: "UY",
  Uzbekistan: "UZ",
  Vanuatu: "VU",
  Venezuela: "VE",
  "Viet Nam": "VN",
  "Virgin Islands (British)": "VG",
  "Virgin Islands (U.S.)": "VI",
  Yemen: "YE",
  Zambia: "ZM",
  Zimbabwe: "ZW",
};

export const languages = {
  AB: "Abkhazian",
  AA: "Afar",
  AF: "Afrikaans",
  SQ: "Albanian",
  AM: "Amharic",
  AR: "Arabic",
  HY: "Armenian",
  AS: "Assamese",
  AY: "Aymara",
  AZ: "Azerbaijani",
  BA: "Bashkir",
  EU: "Basque",
  BN: "Bengali Bangla",
  DZ: "Bhutani",
  BH: "Bihari",
  BI: "Bislama",
  BR: "Breton",
  BG: "Bulgarian",
  MY: "Burmese",
  BE: "Byelorussian",
  KM: "Cambodian",
  CA: "Catalan",
  ZH: "Chinese",
  CO: "Corsican",
  HR: "Croatian",
  CS: "Czech",
  DA: "Danish",
  NL: "Dutch",
  EN: "English American",
  EO: "Esperanto",
  ET: "Estonian",
  FO: "Faeroese",
  FJ: "Fiji",
  FI: "Finnish",
  FR: "French",
  FY: "Frisian",
  GD: "Gaelic",
  GL: "Galician",
  KA: "Georgian",
  DE: "German",
  EL: "Greek",
  KL: "Greenlandic",
  GN: "Guarani",
  GU: "Gujarati",
  HA: "Hausa",
  IW: "Hebrew",
  HI: "Hindi",
  HU: "Hungarian",
  IS: "Icelandic",
  IN: "Indonesian",
  IA: "Interlingua",
  IE: "Interlingue",
  IK: "Inupiak",
  GA: "Irish",
  IT: "Italian",
  JA: "Japanese",
  JW: "Javanese",
  KN: "Kannada",
  KS: "Kashmiri",
  KK: "Kazakh",
  RW: "Kinyarwanda",
  KY: "Kirghiz",
  RN: "Kirundi",
  KO: "Korean",
  KU: "Kurdish",
  LO: "Laothian",
  LA: "Latin",
  LV: "Latvian Lettish",
  LN: "Lingala",
  LT: "Lithuanian",
  MK: "Macedonian",
  MG: "Malagasy",
  MS: "Malay",
  ML: "Malayalam",
  MT: "Maltese",
  MI: "Maori",
  MR: "Marathi",
  MO: "Moldavian",
  MN: "Mongolian",
  NA: "Nauru",
  NE: "Nepali",
  NO: "Norwegian",
  OC: "Occitan",
  OR: "Oriya",
  OM: "Oromo, Afan",
  PS: "Pashto, Pushto",
  FA: "Persian",
  PL: "Polish",
  PT: "Portuguese",
  PA: "Punjabi",
  QU: "Quechua",
  RM: "Rhaeto-Romance",
  RO: "Romanian",
  RU: "Russian",
  SM: "Samoan",
  SG: "Sangro",
  SA: "Sanskrit",
  SR: "Serbian",
  SH: "Serbo-Croatian",
  ST: "Sesotho",
  TN: "Setswana",
  SN: "Shona",
  SD: "Sindhi",
  SI: "Singhalese",
  SS: "Siswati",
  SK: "Slovak",
  SL: "Slovenian",
  SO: "Somali",
  ES: "Spanish",
  SU: "Sudanese",
  SW: "Swahili",
  SV: "Swedish",
  TL: "Tagalog",
  TG: "Tajik",
  TA: "Tamil",
  TT: "Tatar",
  TE: "Tegulu",
  TH: "Thai",
  BO: "Tibetan",
  TI: "Tigrinya",
  TO: "Tonga",
  TS: "Tsonga",
  TR: "Turkish",
  TK: "Turkmen",
  TW: "Twi",
  UK: "Ukrainian",
  UR: "Urdu",
  UZ: "Uzbek",
  VI: "Vietnamese",
  VO: "Volapuk",
  CY: "Welsh",
  WO: "Wolof",
  XH: "Xhosa",
  JI: "Yiddish",
  YO: "Yoruba",
  ZU: "Zulu",
};

export const getPkgServiceMeta = (pkg: any) => {
  const flights = (pkg?.itinerary_setup?.requiredServices ?? []).includes("TR");
  const accNo = _.flatten(Object.values(pkg?.accommodation_data ?? {})).length;
  const addOnNo = _.flatten(Object.values(pkg?.addon_data ?? {})).length;
  const trfNo = _.flatten(Object.values(pkg?.transfer_data ?? {})).length;

  return {
    hasFl: flights,
    accNo,
    hasAcc: accNo > 0,
    addOnNo,
    hasAddOn: addOnNo > 0,
    trfNo,
    hasTrf: trfNo > 0,
  };
};

export const StyleTypeContext = React.createContext({
  type: "type1",
  brand: "",
  cStyler: (props: any) => props,
});

export const AuthTokenContext = React.createContext({ token: null });

export function extractImagesFromPkg({
  tour,
  size,
  hotel = null,
  customOnly = false,
}: {
  tour: any;
  size: string;
  hotel: any;
  customOnly: boolean;
}) {
  if (!size) size = "sm";

  var imgs = [];
  imgs = ((tour?.content?.pkgMainImages ?? []) as any[])
    .map((img) => img?.[`photo_${size}_url`])
    .filter((img) => img);

  if (customOnly) return imgs;

  if (!imgs || imgs.length === 0) {
    imgs = _.flatten(
      Object.entries(tour?.content?.itineraryDaysData ?? {})
        .map((entry: any[]) => {
          if (entry[1].images) {
            return entry[1].images.map((img: any) => img[`photo_${size}_url`]);
          }
          return null;
        })
        .filter((a) => a),
    );
  }

  if ((!imgs || imgs.length === 0) && hotel) {
    imgs = (hotel?.metadata?.images ?? [])
      .map((img: any) => img["medium"])
      .filter((img: any) => img);
  }

  if (!imgs || imgs.length === 0) {
    imgs = _.flatten(
      (tour?.destinations ?? []).map((dest: any) =>
        dest.images.map((img: any) => img[`photo_${size}_url`]),
      ),
    );
  }
  return imgs;
}

export const TranslationContext = React.createContext({});

export function getFlag(input: string) {
  switch (input) {
    case "ZH":
      return <CN />;
    case "FR":
      return <FR />;
    case "US":
      return <US />;
    case "IE":
      return <IE />;
    case "AU":
      return <AU />;
    case "NL":
      return <NL />;
    case "NZ":
      return <NZ />;
    case "GB":
      return <GB />;
    case "ES":
      return <ES />;
    case "IL":
      return <IL />;
    case "MY":
      return <MY />;
    case "LT":
      return <LT />;
    default:
      return null;
  }
}

export const humanizeDuration = ({
  duration,
  withSeconds = false,
}: {
  duration: number;
  withSeconds: boolean;
}) => {
  if (duration < 60) {
    if (duration === 1) {
      return `1 second`;
    }
    return `${duration} seconds`;
  } else if (duration === 60) {
    return `1 minute`;
  } else if (duration < 3600) {
    const minutes = (duration / 60).toFixed();
    const seconds = duration % 60;
    return `${minutes} min ${seconds > 0 ? `${seconds} sec` : ""}`;
  } else {
    const hours = Math.round(duration / (1000 * 60 * 60));
    const minutes = Math.round((duration / (1000 * 60)) % 60);
    const seconds = Math.round((duration / 1000) % 60);
    return `${hours >= 1 ? Math.floor(hours) + "  hrs " : ""} ${
      minutes > 0
        ? ` ${withSeconds ? Math.floor(minutes) : Math.ceil(minutes)} min `
        : ""
    }${seconds > 0 && withSeconds ? `${seconds} sec` : ""}`;
  }
};

export const humanizeDurationFromMins = (minutes: number) => {
  const duration = Duration.fromObject({ minutes });
  const { hours, minutes: remainingMinutes } = duration
    .shiftTo("hours", "minutes")
    .toObject();

  let durationString: string = "";
  if (!!hours && hours > 0) {
    durationString += `${hours > 9 ? "" : "0"}${hours} ${
      hours > 1 ? "hrs" : "hr"
    }`;
  }
  if (!!remainingMinutes && remainingMinutes > 0) {
    durationString += ` ${remainingMinutes > 9 ? "" : "0"}${remainingMinutes} ${
      remainingMinutes > 1 ? "mins" : "min"
    }`;
  }

  return durationString.trim();
};

export const CurrencyContext = React.createContext({
  currency: "",
  defaultCurrency: "",
});

// ================= LOCAL STORAGE ACTION HELPERS ==================
export function setCurrencyToStorage(currency: string) {
  localStorage.setItem("et-currency", currency);
}

export function getCurrencyFromStorage() {
  return localStorage.getItem("et-currency");
}

export function setExchangeRatesToStorage({
  base_currency,
  rates,
}: {
  base_currency: string;
  rates: [];
}) {
  const timestamp = DateTime.now().toISO();
  localStorage.setItem(
    "et-exchange-rates",
    JSON.stringify({ base_currency, rates, timestamp }),
  );
}

export function getExchangeRatesFromStorage() {
  try {
    const exc_rates = localStorage.getItem("et-exchange-rates");
    if (!exc_rates) return null;
    const exchangeRates = JSON.parse(exc_rates);
    return exchangeRates;
  } catch (error) {
    return null;
  }
}

export const withDocTitle = (
  WrappedComponent: any,
  { title }: { title: string },
) => {
  function Comp(props: any) {
    useEffect(() => {
      document.title = title;
      if (!ReactGA4.isInitialized) {
        return;
      }

      ReactGA4.send({ hitType: "pageview", page: window.location.pathname });
    }, []);

    return <WrappedComponent {...props} />;
  }

  return Comp;
};

export function checkIfImageExists(url: string, callback: Function) {
  const img = new Image();
  img.src = url;

  if (img.complete) {
    callback(true);
  } else {
    img.onload = () => {
      callback(true);
    };

    img.onerror = () => {
      callback(false);
    };
  }
}

/**
 * This function takes as input a "Duration ISO 8601" string and returns a string of type "Days: 3, Hours: 5"
 * @param {*} input is a Duration ISO 8601 string
 * @returns a string of type "Days: 3, Hours: 5"
 */
export function getHumanizedFromDurationISO(input: string): string {
  if (!input) return "";
  var output = "";
  var sum = 0;
  try {
    var tmp = Duration.fromISO(input).toObject();
    sum = _.sum(Object.entries(tmp).map((entry) => entry[1]));
    output = _.flatten(
      Object.entries(tmp).map((entry) => [
        `${_.capitalize(entry[0])}: ${entry[1]}`,
      ]),
    ).join(", ");
  } catch (error) {
    console.error("Wrong duration format: ", input);
  }

  return sum ? output : "";
}

export function getAgeFromTimestamp(input: string): number {
  const birthdate = DateTime.fromISO(input);
  const ageInYears = Math.floor(birthdate.diffNow("years").negate().years);
  return ageInYears;
}

/**
 * Provide it in img tag's onError attribute without parenthesis
 * e.g. <img src="..." alt="..." onError={handleNonValidImgFn} />
 * @param {*} event
 */
export function handleNonValidImgFn(event: SyntheticEvent) {
  event.target.onerror = null;
  event.target.src = image_placeholder_s3;
}

export function isValidURL(str: string): boolean {
  try {
    new URL(str);
    return true;
  } catch (error) {
    return false;
  }
}
